"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OWNER_PROPERTIES = exports.OWNERS = exports.PRODUCTS = exports.CONTACTS = exports.COMPANIES = exports.PROPERTY = void 0;
var PROPERTY = 'Property';
exports.PROPERTY = PROPERTY;
var COMPANIES = 'companies';
exports.COMPANIES = COMPANIES;
var CONTACTS = 'contacts';
exports.CONTACTS = CONTACTS;
var PRODUCTS = 'products';
exports.PRODUCTS = PRODUCTS;
var OWNERS = 'owners';
exports.OWNERS = OWNERS;
var OWNER_PROPERTIES = {
  fullname: {
    label: 'Full Name',
    name: 'fullname'
  },
  firstname: {
    label: 'First Name',
    name: 'firstname'
  },
  lastname: {
    label: 'Last Name',
    name: 'lastname'
  },
  email: {
    label: 'Email',
    name: 'email'
  },
  signature: {
    label: 'Signature',
    name: 'signature'
  },
  meetings_link: {
    label: 'Meeting link',
    name: 'meetings_link'
  }
};
exports.OWNER_PROPERTIES = OWNER_PROPERTIES;